<template>
    <div
        v-if="showing && hotel"
        class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 flex items-center justify-center z-50"
    >
        <div class="bg-white p-5 border-2 border-gray-500 rounded-lg w-7/12 max-w-2xl max-h-[90%] overflow-y-auto font-mono relative">
            <h2 class="font-bold text-lg">{{ hotel.name }}</h2>
            <p class="mb-4">{{ hotel.description }}</p>
            <p class="mb-4">Price per night: <strong>{{ hotel.price }}</strong> {{ hotel.currency_code }}</p>
            <label for="wakeTime">Select wake-up time:</label>
            <input type="time" id="wakeTime" v-model="wakeTime" />

            <div class="flex justify-end space-x-2">
                <button type="button" @click="$emit('close')" class="px-4 py-2 border rounded">
                    Cancel
                </button>
                <button
                    class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
                    :disabled="!canSubmit"
                    @click="confirmStay"
                >
                    Stay Here
                </button>
            </div>
        </div>
    </div>
</template>
  
<script setup>
import { computed, ref } from "vue";

const props = defineProps({
    hotel: Object
});

const emit = defineEmits(["close", "stay"]);

const showing = defineModel('modelValue', {
    default: false,
    type: Boolean,
});
  
const wakeTime = ref("07:00");

const canSubmit = computed(() => {
    // Ensure wakeTime is set and hotel is defined
    return wakeTime.value && props.hotel && props.hotel.price > 0;
});

function confirmStay() {
    emit("stay", wakeTime.value, props.hotel);
    emit("close");
}
</script>